import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import Menu from './Menu'
import Button from './Button'
import autobind from 'autobind-decorator'

@withGraphQL(
  gql`
    query getMarkets($countryCode: String) {
      markets(countryCode: $countryCode) {
        ...exchangeNavbarMarkets
      }
    }

    fragment exchangeNavbarMarkets on Market {
      code
      name
      lastTrade {
        price
      }
      currentStats(aggregation: d1) {
        close
        open
        volume
        variation
      }
      mainCurrency {
        code
        name
        symbol
        format
        units
      }
      secondaryCurrency {
        code
        name
        symbol
        format
        units
      }
    }
  `,
  {loading: null, options: {pollInterval: 10000}}
)
export default class Markets extends React.Component {
  static propTypes = {
    markets: PropTypes.array,
    market: PropTypes.object
  }

  state = {}

  closeMenu = event => {
    if (this.state.wrapperRef.contains(event.target)) return
    this.setState({open: false})
  }

  componentDidMount() {
    window.addEventListener('mouseup', this.closeMenu, false)
  }

  componentWillUnmount() {
    window.removeEventListener('mouseup', this.closeMenu)
  }

  setWrapperRef = node => this.setState({wrapperRef: node})

  @autobind
  toggleMenu(event) {
    const {markets} = this.props
    if (!!markets) {
      this.setState({open: !this.state.open})
    }
  }

  render() {
    const {market, markets} = this.props
    const {open} = this.state
    return (
      <div className={styles.container} ref={this.setWrapperRef}>
        <div onClick={this.toggleMenu}>
          <Button open={open} marketName={market.name} />
        </div>
        <div>{this.state.open && <Menu markets={markets} toggleMenu={this.toggleMenu} />}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/index.js